import React from 'react';
import PropTypes from 'prop-types';
import {
  Form,
  FormGroup,
  Label,
  Input,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import { userCan } from '../../helpers/Auth';

const AccessModalSpreadPermissionsPublic = ({
  collectionsCount,
  spreadPermissionsCollections,
  spreadPermissions,
  handleChangeSpreadPermissions,
  handleChangeSpreadPermissionsCollections,
}) => {
  const intl = useIntl();

  return (
    <div className="access-spread">
      <Form className="access-spread-form">
        <FormGroup check>
          <Label check>
            <Input
              type="checkbox"
              name="spread-permissions-public"
              value={userCan('file.create_public')}
              checked={spreadPermissions}
              onChange={handleChangeSpreadPermissions}
            />
            {' '}
            {intl.formatMessage({
              defaultMessage: `Give all registered users access to all files inside 
                {collectionsCount, plural, one {this Collection} other {these Collections}}`,
            }, { collectionsCount })}
          </Label>
        </FormGroup>
        <FormGroup check>
          <Label check>
            <Input
              type="checkbox"
              name="spread-permissions-collections"
              value={true}
              checked={spreadPermissionsCollections}
              onChange={handleChangeSpreadPermissionsCollections}
            />
            {' '}
            {intl.formatMessage({
              defaultMessage: `Give all registered users access to all sub-Collections inside 
                {collectionsCount, plural, one {this Collection} other {these Collections}}`,
            }, { collectionsCount })}
          </Label>
        </FormGroup>
      </Form>
    </div>
  );
};

AccessModalSpreadPermissionsPublic.propTypes = {
  spreadPermissions: PropTypes.bool.isRequired,
  spreadPermissionsCollections: PropTypes.bool.isRequired,
  collectionsCount: PropTypes.number.isRequired,
  handleChangeSpreadPermissions: PropTypes.func.isRequired,
  handleChangeSpreadPermissionsCollections: PropTypes.func.isRequired,
};

export default AccessModalSpreadPermissionsPublic;
